<template>
  <div data-testid="orders-list">
    <HandleSection
      class="orders-list"
      :error="error"
      :loading="loading"
      section-title="Ordens"
      error-title="Não foi possível carregar suas ordens"
      :refresh="emitOnRetry"
    >
      <Heading class="orders-list__title" :level="3">Ordens</Heading>

      <template v-if="hasOrders">
        <OrderRow
          v-for="order in orders"
          :key="order.id"
          class="orders-list__info"
          :order="order"
          @on-row-click="openOrderModal"
        />
        <a :href="viewMoreHref" @click="emitOnViewMoreClick">
          <Row chevron has-interaction>
            <template #top-left>
              <b>Ver todas as ordens</b>
            </template>
          </Row>
        </a>
      </template>
      <template v-else>
        <slot name="empty-state">
          <BaseText
            class="orders-list__empty-text"
            :color="NebraskaColors.textSecondary"
            size="lg"
          >
            Você ainda não possui ordens.
          </BaseText>
        </slot>
      </template>
    </HandleSection>
    <OrderModal
      v-if="currentSelectedOrder"
      :id="currentSelectedOrder.id"
      :is-open="isOrderModalOpen"
      @close="closeOrderModal"
    />
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

import { BaseText, Heading, Row } from '@warrenbrasil/nebraska-web';
import { HandleSection } from '@/modules/trade/components/HandleSection';
import { OrderRow } from '@/modules/trade/components/OrderRow';
import { OrderModal } from '@/modules/trade/components/OrderModal';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { OrderSummary } from '@/modules/trade/services/orders';

@Component({
  components: {
    BaseText,
    HandleSection,
    OrderModal,
    OrderRow,
    Heading,
    Row
  }
})
export default class OrdersList extends Vue {
  @Prop({ type: Array, required: false })
  readonly orders?: OrderSummary[];

  @Prop({ type: Boolean, default: false })
  readonly loading!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly error!: boolean;

  @Prop({ type: String, required: true })
  readonly viewMoreHref!: string;

  @Emit('on-retry')
  emitOnRetry() {}

  @Emit('on-view-more-click')
  emitOnViewMoreClick() {}

  @Emit('on-order-click')
  emitOnOrderClick(_order: OrderSummary) {}

  currentSelectedOrder: OrderSummary | null = null;
  isOrderModalOpen = false;

  readonly NebraskaColors = NebraskaColors;

  openOrderModal(order: OrderSummary) {
    this.emitOnOrderClick(order);
    this.currentSelectedOrder = order;
    this.isOrderModalOpen = true;
  }

  closeOrderModal() {
    this.isOrderModalOpen = false;
  }

  get hasOrders() {
    return this.orders && this.orders?.length > 0;
  }
}
</script>

<style lang="less" scoped>
.orders-list {
  padding-bottom: @size-spacing-x800;

  &__info {
    white-space: nowrap;
  }

  &__title {
    padding-bottom: @size-spacing-x300;
  }

  &__empty-text {
    border-top: @size-border-x400 solid @divider-primary;
    padding-top: @size-spacing-x350;
  }
}
</style>
